// extracted by mini-css-extract-plugin
export default {"container":"src-slices-EmailFormSlice-EmailFormSlice__container","form":"src-slices-EmailFormSlice-EmailFormSlice__form"};